import { Fragment } from "react";
import { t } from "i18next";

import { TableLoader } from "../molecules/TableLoader";
import ColumnText from "../molecules/ColumnText";
import { Button } from "../atoms/Button";
import { Empty } from "./Empty";

export type AgreementsTableProps = {
  isLoading: boolean;
  agreements: any[];
  onDownloadTicket: (transaction: any) => void;
};

export const AgreementsTable: React.FC<AgreementsTableProps> = ({
  isLoading,
  agreements,
  onDownloadTicket,
}) => {
  return (
    <div className="flex-1 overflow-scroll flex flex-col border">
      <div className="flex flex-1 flex-col">
        {isLoading ? (
          <TableLoader columns={4} />
        ) : (
          <Fragment>
            {agreements.length === 0 ? (
              <Empty texto={t("transaction.views.no_task")} />
            ) : (
              <Fragment>
                <table className="divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("general.name")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("general.total")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("pages.accounting.movements")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("general.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {agreements.map((agreement: any) => (
                      <tr key={agreement.id}>
                        <ColumnText wrap title={agreement.name} />
                        <ColumnText
                          wrap
                          title={`${agreement.currency.toUpperCase()} ${parseFloat(agreement.amount).toFixed(2)}`}
                        />
                        <ColumnText wrap title={agreement.movement} />
                        <ColumnText
                          wrap
                          title={
                            <div className="flex gap-2">
                              <Button
                                disabled={agreement.amount === 0}
                                text={t("accounting.views.ticket")}
                                onClick={() => onDownloadTicket(agreement)}
                              />
                            </div>
                          }
                        />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default AgreementsTableProps;
